/*
  Event Override Layer
*/
export const eventOverrideSourceId = 'event-override-overlay'
export const eventOverrideLayerId = 'event-override-transparent-fill'

/*
  Site Polygons
*/
export const sitePolygonsSourceId = 'site-polygons'
export const sitePolygonFillsLayerId = 'site-fills'
export const sitePolygonOutlinesLayerId = 'site-outlines'

/*
  SelectedSite
*/
export const selectedSiteExternalSourceId = 'site-external-polygon'
export const selectedSiteExternalLayerId = 'site-external-fill'
export const selectedSiteExternalFeatureId = 'site-external-feature'

export const selectedSiteSourceId = 'selected-site-polygon'
export const selectedSiteFillLayerId = 'selected-site-fill'
export const selectedSiteOutlineLayerId = 'selected-site-outline'
export const selectedSiteOutlineClickId = 'selected-site-outline-click'

export const footprintsSourceId = 'remedy-footprints'
export const footprintsLayerId = 'footprint-fills'

/*
  Parcel Select
*/
// id for outline of selected parcels
export const parcelSelectLayerId = 'parcel-select.parcel-select-lv.stroke'

/*
  Lists
*/
/*
  Tree Canopy
*/
export const treeCanopySourceId = 'tree-canopy'
export const treeCanopyFillLayerId = 'tree-canopy-fill'
export const treeCanopyOutlineLayerId = 'tree-canopy-outline'

/*
  Lists
*/
// ordered bottom -> top
export const allSketchLayerIds = [
  sitePolygonFillsLayerId,
  sitePolygonOutlinesLayerId,
  selectedSiteExternalLayerId,
  selectedSiteOutlineLayerId,
  selectedSiteOutlineClickId,
  footprintsLayerId,
  selectedSiteFillLayerId
]
